import React from "react";

const MegastrikeRules = () => {
  return (
    <div>
      <p>MegaStrike 10 is similar in several respects to Soccer 10 but with one huge difference - you are betting on players rather than teams.</p>

      <p>
        To win the bet you must predict how many goals each of 10 players (labelled P1 to P10) will score in a designated soccer match, choosing from three
        result options:
      </p>
      <ol>
        <li> = Player scores no goals</li>
        <li> = Player scores 1 goal</li>
        <li> = Player scores 2 goals or more</li>
      </ol>

      <p>
        As with TAB’s other soccer bets, you can play a single or multiple entry. With a single entry, you select ONE option or choice for each player and the
        bet costs R2.
      </p>

      <p>
        With a multiple entry, you can choose more than one score option for one or more players. The cost is R2 per combination. To calculate the number of
        combinations, multiply out the total number of options or choices for each player. Then take that total and multiply it by 2 to calculate the cost of
        the bet.
      </p>

      <h1>Examples:</h1>
      <p>
        You choose all three options for P1 (Player 1), two options for P2 and one for each of P3, P4, P5, P6, P7, P8, P9 and P10. That's 3x2x1x1x1x1x1x1x1x1= 6
        combinations x R2 = R12.
      </p>

      <p>You choose two score options for each of P1 to P8 and one for P9 and P10. That's 2x2x2x2x2x2x2x2x1x1 =256 x 2 = R512</p>

      <h1>Key Info:</h1>
      <p>If nobody forecasts all 10 players’ scores correctly the pool is carried forward.</p>

      <p>
        A player will be deemed to have participated in a match if they start the match on the field or are substituted onto the field anytime during the normal
        90-minute playing period plus any referee’s optional time that may be played.
      </p>

      <p>
        If a player participates in a match as per above and then leaves the field for any reason, they are deemed to have participated in the match,
        irrespective of the number of minutes played in the match.
      </p>

      <p>If a player has not participated in the match at all, all possible score results for that player will apply for purposes of calculating a dividend.</p>

      <p>
        Only goals, including penalties, scored by players during the normal 90-minute playing period plus any referee’s optional time qualify in determining
        the official results. Own goals and goals scored in extra time and penalty shootouts do not count.
      </p>
      <p>
        If you play MegaStrike 10 at a TAB, please note the bet must be called as follows to a teller : MegaStrike 10, Track Key 52 and then your choices for
        each player.
      </p>
    </div>
  );
};

export default MegastrikeRules;
